import { useCallback } from 'react';

import type { Wallet } from '@sorare/wallet-shared';

import WalletNew from '#src/lib/wallet/index.ts';

const useCreateWallet = () => {
  return useCallback(async (password: string, email: string) => {
    const wallet = await WalletNew.create();

    return wallet.export(password, email) as Promise<Wallet>;
  }, []);
};

export default useCreateWallet;
